// extracted by mini-css-extract-plugin
export var avatarContainer = "_hd-0";
export var avatarTypingWave = "_hd-i";
export var gray = "_hd-f";
export var green = "_hd-c";
export var icon = "_hd-9";
export var image = "_hd-1";
export var lg = "_hd-6";
export var md = "_hd-5";
export var presenceDot = "_hd-b";
export var red = "_hd-d";
export var sm = "_hd-4";
export var status = "_hd-a";
export var typingDot = "_hd-h";
export var typingPill = "_hd-g";
export var xl = "_hd-7";
export var xs = "_hd-3";
export var xxl = "_hd-8";
export var xxs = "_hd-2";
export var yellow = "_hd-e";